import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'reporting-tool-chip',
    templateUrl: './reporting-tool-chip.component.html',
    styleUrls: ['./reporting-tool-chip.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReportingToolChipComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ReportingToolChipComponent implements ControlValueAccessor {
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    @Input() value: string[] = [];
    @Input() removable: boolean;
    @Input() selectable: boolean;
    @Input() readonly: boolean;
    @Input() placeholder: string;
    @Input() showIconForValues: { icon: IconProp | string[]; values: string[] };

    writeValue(value: any) {
        if (value !== undefined) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
        /* Form control touched handler */
    }

    propagateChange = (_: any) => {
        // ControlValueAccessor callback placeholder
    };

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        if (!this.value) {
            this.value = [];
        }

        if ((value || '').trim() && !this.value.some(e => e.toLowerCase() === value.trim().toLowerCase())) {
            this.value.push(value.trim());
            this.propagateChange(this.value);
        }

        if (input) {
            input.value = '';
        }
    }

    remove(item: string): void {
        const index = this.value.indexOf(item);

        if (index >= 0) {
            this.value.splice(index, 1);
            this.propagateChange(this.value);
        }
    }

    isExisting(item: string): boolean {
        return this.showIconForValues.values.some(e => e === item);
    }
}
